import { render } from "./balanceUp.html?vue&type=template&id=24e9be99&scoped=true&ts=true"
import script from "./balanceUp.ts?vue&type=script&lang=ts"
export * from "./balanceUp.ts?vue&type=script&lang=ts"

import "./balanceUp.scss?vue&type=style&index=0&id=24e9be99&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e9be99"]])

export default __exports__